import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './CoinDiceRoller.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const CoinDiceRoller = () => {
  useDocumentMeta({
    title: 'Cara ou Coroa e Dado Virtual Online  jarder.dev',
    description:
      'Jogue cara ou coroa ou role um dado virtual (1 a 6). Grátis, ' +
      'direto no navegador, sem cadastro.',
  })

  const [coinResult, setCoinResult] = useState(null)
  const [coinFlipping, setCoinFlipping] = useState(false)
  const [diceResult, setDiceResult] = useState(null)
  const [diceRolling, setDiceRolling] = useState(false)
  const [diceCount, setDiceCount] = useState('1')

  const flipCoin = () => {
    if (coinFlipping) return
    setCoinFlipping(true)
    setCoinResult(null)
    window.setTimeout(() => {
      const result = Math.random() < 0.5 ? 'Cara' : 'Coroa'
      setCoinResult(result)
      setCoinFlipping(false)
      trackEvent('tool_generate', { tool: 'coin_flip' })
    }, 700)
  }

  const rollDice = () => {
    if (diceRolling) return
    const n = Math.max(1, Math.min(Number.parseInt(diceCount, 10) || 1, 6))
    setDiceRolling(true)
    setDiceResult(null)
    window.setTimeout(() => {
      const rolls = Array.from(
        { length: n },
        () => 1 + Math.floor(Math.random() * 6),
      )
      setDiceResult(rolls)
      setDiceRolling(false)
      trackEvent('tool_generate', { tool: 'dice_roll', count: n })
    }, 500)
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Cara ou Coroa e Dado Virtual</h1>
      <p className="tool-disclaimer">
        Sorteios rápidos, aleatórios de verdade  sem cadastro.
      </p>

      <section className="coin-dice-section">
        <h2>Cara ou coroa</h2>
        <div className={`coin ${coinFlipping ? 'coin-flipping' : ''}`}>
          {coinResult || '?'}
        </div>
        <button type="button" className="tool-button" onClick={flipCoin}>
          Jogar moeda
        </button>
      </section>

      <section className="coin-dice-section">
        <h2>Dado virtual</h2>
        <div className="tool-field" style={{ maxWidth: 160, margin: '0 auto 16px' }}>
          <label htmlFor="dice-count">Quantos dados (1-6)</label>
          <input
            id="dice-count"
            type="number"
            min="1"
            max="6"
            value={diceCount}
            onChange={(e) => setDiceCount(e.target.value)}
          />
        </div>
        <div className="dice-row">
          {(diceResult || [0]).map((value, i) => (
            <div
              className={`die ${diceRolling ? 'die-rolling' : ''}`}
              key={i}
            >
              {value || '?'}
            </div>
          ))}
        </div>
        <button type="button" className="tool-button" onClick={rollDice}>
          Rolar dado
        </button>
      </section>

      <div className="tool-info-section">
        <h2>É aleatório de verdade?</h2>
        <p>
          Os resultados usam o gerador de números pseudoaleatórios do
          próprio navegador, com a mesma probabilidade de 50/50 para cara
          ou coroa e 1/6 para cada face do dado  suficiente para
          decisões do dia a dia, sorteios entre amigos ou jogos de
          tabuleiro. Nada é enviado a um servidor: cada sorteio acontece
          localmente, na hora do clique.
        </p>
      </div>
    </div>
  )
}

export default CoinDiceRoller
